import Vue from 'vue';
import resetState from '@/helpers/resetState';
import store from '@/store';
import { ABI } from './ABI';
import { formatData } from '@/constants/commonContent';
import { messages } from '@/constants/messages';
import { Contract } from 'web3-eth-contract';
import CONFIG from '@/config';

const FEATURE_NAME = 'BalManagerFeature';

let from;

async function contract(): Promise<Contract> {
  from = {from: store.getters.getWallet};
  const address = store.getters.getFeatureAddress(FEATURE_NAME);
  return new Promise(resolve => {
    let contract = new window.web3.eth.Contract(ABI, address);
    resolve(contract);
  });
}

const initialState = {
  balances: {
    total: 0
  },
  minTotal: 0
};

const state = {
  balances: initialState.balances,
  minTotal: initialState.minTotal
};

const getters = {
  getBalances: state => {
    return state.balances
  },
  getMinTotal: state => {
    return state.minTotal;
  }
};

const mutations = {
  setFeatureBalance: (state, item) => {
    state.balances = Object.assign({}, state.balances, {[item.featureName]: item.balance});
  },
  setTotalBalance: (state, balance) => {
    let _balance = state.balances.total || 0;
    _balance += balance;
    state.balances = Object.assign({}, state.balances, {total: _balance});
  },
  setMinTotal: (state, item) => {
    state.minTotal = item;
  },
  resetBalManagerFeature: (state) => {
    resetState(state, initialState);
  }
};

const actions = {
  initBalManagerFeature({ dispatch, commit, getters }) {
    dispatch('getMinTotalDapp');
    setTimeout(() => {
      if (getters.isOwner()) {
        CONFIG.featuresForBalance!.forEach(featureName => {
          dispatch('getFeaturesBalanceDapp', featureName);
        });
      }
    }, 1000);
  },
  /**
   * Create voting for members
   * @param subject {string}
   * @param description {string}
   * @param deadlineTime {number}
   */
  getFeaturesBalanceDapp({ commit, dispatch }, featureName) {
    contract().then(contract => {
      contract.methods.getBalance(featureName)
        .call()
        .then((balance) => {
          commit('setFeatureBalance', {
            featureName,
            balance: Number(formatData.fromWei(parseInt(balance)))
          });
          commit('setTotalBalance', Number(formatData.fromWei(parseInt(balance))));
        })
        .catch((err) => {
          console.error(err);
          Vue.toasted.error(messages.canceledVoting);
        });
    });
  },
  getMinTotalDapp({commit}) {
    contract().then(contract => {
      contract.methods.getMinTotal()
        .call()
        .then((balance) => {
          console.log('Min Total: ', balance);
          commit('setMinTotal', Number(formatData.fromWei(parseInt(balance))));
        })
        .catch((err) => {
          console.error(err);
          Vue.toasted.error(messages.canceledVoting);
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
